<!-- Content -->
@if ((pageSharedFacade.currentSelectedInfoPage$ | async); as infoPage) {
  <div class="mdsf-container"
    >
    <div class="mdsf-page-container align-items-center scrollable m-0 p-2 w-100 flex-grow-1">
      <div class="page-content">
        <div class="scrollable editor-input ng-scope">
          <h1>{{ infoPage.header }}</h1>
        </div>
        <div class="scrollable editor-input ng-scope"
        [innerHTML]="infoPage.body"></div>
      </div>
    </div>
    <medsurf-footer class="d-none d-md-inline"
      [links]="footerLinks"
      align="center">
    </medsurf-footer>
  </div>
}